import { render, staticRenderFns } from "./VSubtitle.vue?vue&type=template&id=2363e412&scoped=true&"
import script from "./VSubtitle.vue?vue&type=script&lang=js&"
export * from "./VSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363e412",
  null
  
)

export default component.exports